import { render, staticRenderFns } from "./DX.vue?vue&type=template&id=015ad21c&scoped=true&"
import script from "./DX.vue?vue&type=script&lang=js&"
export * from "./DX.vue?vue&type=script&lang=js&"
import style0 from "./DX.vue?vue&type=style&index=0&id=015ad21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ad21c",
  null
  
)

component.options.__file = "DX.vue"
export default component.exports